/* global axios */
import ApiClient from './ApiClient';

class GoogleLeadConfigAPI extends ApiClient {
  constructor() {
    super('google_lead_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, { google_lead_config: data });
  }

  regenerate() {
    return axios.post(`${this.url}/regenerate`);
  }
}

export default new GoogleLeadConfigAPI();
